const publicUrl = process.env.PUBLIC_URL || "";

function createGalleryImage(folder, filename) {
  return `${publicUrl}/gallery/${folder}/${filename}`;
}

const galleryEvents = [
  {
    id: "memorial-zielazka",
    slug: "memorial-zielazka",
    title: {
      pl: "XII Memorial im. Henryka Zelazka",
      en: "12th Henryk Zelazka Memorial",
    },
    description: {
      pl: "Poznan ponownie goscil turniej hokeja na trawie dla dzieci i mlodziezy. W wydarzeniu wzielo udzial ponad 20 druzyn z calej Polski, a dzien byl pelen sportowej rywalizacji, fair play i rodzinnej atmosfery.",
      en: "Poznan once again hosted a youth field hockey tournament. More than 20 teams from across Poland took part in a day filled with competition, fair play, and a strong family atmosphere.",
    },
    date: "2026-05-30",
    time: "09:30",
    location: {
      pl: "Boisko, ul. Promienista 27, Poznan",
      en: "Pitch, 27 Promienista Street, Poznan",
    },
    eventLink:
      "https://www.facebook.com/events/ul-promienista-27-pozna%C5%84/xii-memoria%C5%82-im-henryka-zielazka/2474173056389378/",
    images: [
      createGalleryImage("memorial-zielazka", "1.jpg"),
      createGalleryImage("memorial-zielazka", "2.jpg"),
      createGalleryImage("memorial-zielazka", "3.jpg"),
      createGalleryImage("memorial-zielazka", "4.jpg"),
      createGalleryImage("memorial-zielazka", "6.jpg"),
      createGalleryImage("memorial-zielazka", "7.jpg"),
      createGalleryImage("memorial-zielazka", "8.jpg"),
      createGalleryImage("memorial-zielazka", "9.jpg"),
      createGalleryImage("memorial-zielazka", "10.jpg"),
      createGalleryImage("memorial-zielazka", "11.jpg"),
      createGalleryImage("memorial-zielazka", "12.jpg"),
      createGalleryImage("memorial-zielazka", "13.jpg"),
      createGalleryImage("memorial-zielazka", "14.jpg"),
      createGalleryImage("memorial-zielazka", "15.jpg"),
      createGalleryImage("memorial-zielazka", "16.jpg"),
      createGalleryImage("memorial-zielazka", "17.jpg"),
    ],
  },
  {
    id: "mecz-orleta",
    slug: "mecz-orleta",
    title: {
      pl: "Pierwsze zwyciestwo z Orletami Sosnowiec",
      en: "First win against Orleta Sosnowiec",
    },
    description: {
      pl: "Kadry z wieczoru, w ktorym Warsaw Hockey Club wygral 3:1 z UKS Orleta Sosnowiec-Gornik i zapisal pierwsze zwyciestwo w historii klubu na poziomie I ligi.",
      en: "Scenes from the evening when Warsaw Hockey Club beat UKS Orleta Sosnowiec-Gornik 3-1 and recorded the first League I win in club history.",
    },
    date: "2026-05-23",
    time: "18:00",
    location: {
      pl: "Warszawa, ul. Marymoncka 34, boisko nr 3",
      en: "Warsaw, 34 Marymoncka Street, pitch 3",
    },
    images: [
      createGalleryImage("mecz-orleta", "1.jpg"),
      createGalleryImage("mecz-orleta", "2.jpg"),
      createGalleryImage("mecz-orleta", "3.jpg"),
    ],
  },
  {
    id: "open-training",
    slug: "open-training",
    title: {
      pl: "Otwarte treningi",
      en: "Open Training Sessions",
    },
    description: {
      pl: "Miejsce na zdjecia z otwartych treningow, pierwszych prob i wspolnych wieczorow na boisku.",
      en: "A home for photos from open sessions, first tries, and shared evenings on the pitch.",
    },
    date: "2026-05-01",
    location: {
      pl: "Warszawa",
      en: "Warsaw",
    },
    images: [
      createGalleryImage("open-training", "hero3.jpg"),
      createGalleryImage("open-training", "hero5.jpg"),
    ],
  },
  {
    id: "team-nights",
    slug: "team-nights",
    title: {
      pl: "Wieczorne sesje druzyny",
      en: "Team Night Sessions",
    },
    description: {
      pl: "Kadry z treningow i spotkan, ktore pokazuja rytm pracy zespolu i atmosfere klubu.",
      en: "Photos from practices and meetups that show the rhythm of the team and the atmosphere of the club.",
    },
    date: "2026-05-10",
    location: {
      pl: "Warszawa",
      en: "Warsaw",
    },
    images: [
      createGalleryImage("team-nights", "hero6.jpg"),
      createGalleryImage("team-nights", "hero7.jpg"),
    ],
  },
];

export default galleryEvents;
